export default "__VITE_ASSET__B3q0zYT6__"